namespace RecordShield.Modules.Workspace {
    export interface SerialKeyResponse extends Serenity.ServiceResponse {
        SerialKey?: string;
    }
}
